@if (gpsLink()) {
    <div class="hideMobile">
        <div class="tab__title">{{ 'directions' | translate }}</div>
        <div id="drawer-map" class="drawer-map-container" [class.hidden]="!showList()"></div>
        <div class="map-input">
            <si-form-item [label]="'directionsOrigin' | translate">
                <input
                    class="form-control"
                    [ngModel]="origin()"
                    (ngModelChange)="origin.set($event)"
                    [attr.aria-label]="'directionsOrigin' | translate"
                    (keyup.enter)="getDirections()"
                />
            </si-form-item>
            <div>
                <button
                    type="button"
                    class="btn btn-primary"
                    [attr.aria-label]="'accessibility.get-directions' | translate"
                    (click)="getDirections()"
                >
                    {{ 'accessibility.get-directions' | translate }}
                </button>
            </div>
        </div>
        <div class="map-options" [class.hidden]="!showList()">
            <si-icon
                role="button"
                tabindex="0"
                [attr.aria-label]="'accessibility.travel-by-car' | translate"
                (click)="getDirections('car')"
                (keydown.enter)="getDirections('car')"
                (keydown.space)="getDirections('car'); $event.preventDefault()"
                class="travel-icon"
                icon="element-go-to"
                [class.active]="travelMode() === 'car'"
            />
            <si-icon
                role="button"
                tabindex="0"
                [attr.aria-label]="'accessibility.travel-by-public-transport' | translate"
                (click)="getDirections('bus')"
                (keydown.enter)="getDirections('bus')"
                (keydown.space)="getDirections('bus'); $event.preventDefault()"
                class="travel-icon"
                icon="element-train"
                [class.active]="travelMode() === 'bus'"
            />
        </div>
        <div id="directionsList" [class.hidden]="!showList()"></div>
    </div>
    <div class="onlyMobile directions">
        <span>{{ 'directionsMobileHeader' | translate }}</span>
        <img src="assets/svgs/direction_icon.svg" />
        <a [href]="gpsLink()" target="_blank" class="geo-link">{{ 'directionsMobileLink' | translate }}</a>
    </div>
}
